<div class="row">
  <div class="col-12">
    <form (ngSubmit)="onSubmitForm()" [formGroup]="form">
      <div class="row">
        <div class="col-md-12">
          <app-search-by-drop-down formControlName="searchTerm" [searchTerms]="searchTerms"> </app-search-by-drop-down>
        </div>
      </div>

      <div class="row" [ngSwitch]="searchTerm">
        <div class="col-12" *ngSwitchCase="[FiduciarySearchTerms.Escrow, FiduciarySearchTerms.All] | switchMultiCase: searchTerm">
          <div class="form-group">
            <label for="fideicomiso">Fideicomiso:</label>
            <uni-select
              formControlName="fideicomiso"
              [clearable]="false"
              bindLabel="sNombreCorto"
              bindValue="key"
              labelForId="fideicomiso"
              [items]="escrows$ | async"
            >
            </uni-select>
          </div>
        </div>

        <div
          class="col-12"
          *ngSwitchCase="[FiduciarySearchTerms.Application, FiduciarySearchTerms.All] | switchMultiCase: searchTerm"
        >
          <uni-form-field>
            <uni-label>Número de Solicitud:</uni-label>
            <input uniInput formControlName="requestId" />
          </uni-form-field>
        </div>

        <div
          class="col-md-12"
          *ngSwitchCase="[FiduciarySearchTerms.Status, FiduciarySearchTerms.All] | switchMultiCase: searchTerm"
        >
          <div class="form-group">
            <label for="status">Estatus:</label>
            <uni-select
              labelForId="status"
              bindLabel="nEstadoSolicitud"
              bindValue="key"
              formControlName="status"
              [items]="status$ | async"
            ></uni-select>
          </div>
        </div>

        <ng-container
          *ngSwitchCase="[FiduciarySearchTerms.ApplicationTypes, FiduciarySearchTerms.All] | switchMultiCase: searchTerm"
        >
          <div class="col-12">
            <div class="form-group">
              <label for="type">Dependencia:</label>
              <uni-select
                labelForId="type"
                bindLabel="sNombre"
                bindValue="key"
                formControlName="dependency"
                [items]="dependencies$ | async"
              ></uni-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="type">Tipo:</label>
              <uni-select
                labelForId="type"
                bindLabel="sNombre"
                bindValue="key"
                formControlName="type"
                [items]="types$ | async"
              ></uni-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="subType">SubTipo:</label>
              <uni-select
                labelForId="subType"
                bindLabel="sNombre"
                bindValue="key"
                formControlName="subType"
                [items]="subTypes$ | async"
              ></uni-select>
            </div>
          </div>
        </ng-container>

        <div class="col-12" *ngIf="searchTerm">
          <div class="form-group">
            <app-date-input
              *ngIf="searchTerm !== FiduciarySearchTerms.Application"
              label="Fecha"
              formControlName="dateRange"
              endDateName="endDate"
              startDateName="startDate"
              [range]="true"
              [requiredMark]="true"
              maxDate="now"
            >
            </app-date-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 pt-3 text-right">
          <button type="submit" [disabled]="form.invalid" uni-button>Consultar</button>
        </div>
      </div>
    </form>
  </div>
</div>
